<template>
	<div class="home">
		<div class="home_con_1">
			<img class="home_con_1_img" :src="bannerImage" />
		</div>
		<div class="home_con_2">
			<ProductCenter />
		</div>
	</div>
</template>

<script>
import { bannerApi, baseImgUrl } from '../netTool/api';
import ProductCenter from '../components/products.vue';

export default {
	name: 'Home',
	components: {
		ProductCenter
	},
	data() {
		return {
			bannerImage: ''
		};
	},
	async mounted() {
		try {
			const navId = 3;
			const response = await bannerApi.getBanner(navId);
			if (response.success) {
				this.bannerImage = baseImgUrl + response.banner.image_url;
			}
		} catch (error) {}
	}
};
</script>

<style scoped>
.home {
	--base-width: 1920;
	--scale-factor: 2.5;

	width: 100%;
	overflow: hidden;
}

.home_con_1_img {
	width: 100%;
	height: auto;
	background-repeat: no-repeat;
	background-position: center;
}

.home_con_2 {
	background-color: #f8f8f8;
}
</style>
